const CreatorWallet = () => <div>Creator Wallet</div>;
export default CreatorWallet;